import { Container } from "../../styles/Container";
import { StyledDashboardHeader } from "./styled";
import logo from "../../assets/icons/Logo.svg"
import { StyledBtn } from "../../styles/Buttons"

const DashboardHeader = ({leaveFunction})=>{

    return(                     
        <StyledDashboardHeader>
            <Container>
                <img src={logo} alt="Kenzie Hub" />
                <StyledBtn onClick={leaveFunction} small BGcolor="var(--color-grey-3)" size="60px" fontSize="12px">Sair</StyledBtn>
            </Container>
        </StyledDashboardHeader>
    );
}

export default DashboardHeader